import { css } from '@eti/styles';
import { useSiteContext, useTranslation } from '@eti/providers';
import { vars, Text, Stack, textVariants } from '@etg/wings';
import { useResultPageContext } from '../contexts/ResultPageContext';
import ResultTripCard from './ResultTripCard';
import { RESULT_TRIPS } from './constants';

const selectedTripCardWrapperStyles = css`
  background: ${vars.colors.card.highlight.background};
  border-radius: ${vars.card.borderRadius};
  padding: 2px;
`;

const titleStyles = css`
  color: ${vars.colors.card.highlight.foreground};
  padding: 8px 14px;
`;

const resultTripCardStyles = css`
  border-radius: calc(${vars.card.borderRadius} - 2px);
`;

export const SelectedTripCard = () => {
  const { selectedTrip, setIsSelfTransferModalOpen, setIsItineraryDrawerSelfTransferModalOpen } =
    useResultPageContext();
  const { partner } = useSiteContext();
  const { t } = useTranslation();
  const selectedtripTitle =
    t(`Result.SelectedTrip.PartnerName.${partner}`) || t('Result.SelectedTrip.NoPartner.Heading');

  return (
    <Stack
      className={selectedTripCardWrapperStyles}
      data-testid="resultPage-selectedTrip-wrapper"
      spacing={0}
    >
      <Text className={titleStyles} variant={textVariants._14_BOLD}>
        {selectedtripTitle}
      </Text>
      <ResultTripCard
        customStyles={resultTripCardStyles}
        resultTripType={RESULT_TRIPS.SELECTED}
        setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
        setIsSelfTransferModalOpen={setIsSelfTransferModalOpen}
        trip={selectedTrip}
      />
    </Stack>
  );
};
